export default function UsedInformation() {
    return (
        <section>
            <h2 id="used-information" data-testid="used-information">
                II. COMO UTILIZAMOS OS DADOS
            </h2>
            <p>
                As informações coletadas pela AMBEV têm como finalidade
                possibilitar a utilização pela empresa e seu(s) gestor(es) do
                App e, eventualmente, disponibilizar ao Usuário a opção para que
                ele receba sugestões e/ou propostas de produtos, soluções ou
                serviços, e os benefícios dos Apps parceiros e da AMBEV.
            </p>
            <p>
                As informações coletadas poderão, ainda, ser utilizadas para
                fins de comunicação com as empresas e gestores cadastrados e de
                envio de informações relativas à utilização dos recursos
                disponibilizados NO APP Smart Cargas.
            </p>
            <p>
                Base Legal: Nestes casos, o tratamento de dados é autorizado
                pelo inciso I do artigo 7º da Lei nº 13.709/2018, a Lei Geral de
                Proteção de Dados (“Lei Geral de Proteção de Dados - LGPD”).
            </p>
        </section>
    );
}
